import { Link } from "react-router-dom";
import { topics } from "@/mocks/tv/topics";

export default function TopicSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-6 md:mb-8">
        <div>
          <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-600 uppercase tracking-widest mb-2">
            <span className="w-6 h-1 flex items-center justify-center">
              <span className="block w-6 h-1 rounded-full bg-accent-500" />
            </span>
            精选合集
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">影视专题推荐</h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-2xl">
            按主题为你整理好片单，从年度大盘点到日韩口碑剧，一站式发现更多喜爱内容。
          </p>
        </div>
        <Link
          to="/search"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
        >
          浏览全部
          <i className="ri-arrow-right-s-line text-lg w-5 h-5 flex items-center justify-center" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {topics.map((topic) => (
          <Link
            key={topic.id}
            to={topic.href}
            className="group relative block h-[190px] rounded-lg overflow-hidden bg-secondary-900"
          >
            <img
              src={topic.image}
              alt={`${topic.title}专题`}
              title={`${topic.title} - 绍宋影视`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/92 via-foreground-950/55 to-foreground-950/15" />
            <div className="relative w-full h-full p-5 flex flex-col justify-end">
              <span className="inline-flex w-fit items-center gap-1 px-2.5 py-1 mb-3 text-[11px] rounded-full bg-secondary-500 text-background-50">
                <i className="ri-price-tag-3-line text-xs w-4 h-4 flex items-center justify-center" />
                {topic.count} 部作品
              </span>
              <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">{topic.title}</h3>
              <p className="text-sm text-background-200 mt-1 line-clamp-1">{topic.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}